import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
  useCloneEntity,
} from 'gossamer-front-end';
import { Task, TaskRow } from 'gossamer-model';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';
import { FieldType, PersistenceType, ReferenceField } from 'gossamer-unified';
import { Institution, UserView } from 'cb-model';

export const ActiveTaskReport = (): React.JSX.Element => {
  const LocalTask = useCloneEntity(Task, (local) => {
    Object.values(local.fields).forEach((field) => {
      field.sortable = false;
      field.listColumn = false;
    });
    local.fields.label.listColumn = true;
    local.fields.created_at.listColumn = true;
    local.fields.institution_id.type = FieldType.Reference;
    (local.fields.institution_id as ReferenceField).refEntity = Institution;
    local.fields.assigned_to.listColumn = true;
    local.fields.assigned_to.type = FieldType.Reference;
    (local.fields.assigned_to as ReferenceField).refEntity = UserView;
    (local.fields.assigned_to as ReferenceField).linkURL = (key: string) => `/admin/user/display/${key}?tab=tasks`;
    (local.fields as any).elapsed = {
      seq: 990,
      type: FieldType.Text,
      label: 'Elapsed',
      listColumn: true,
      persistence: PersistenceType.FrontEndOnly,
      evaluateFrontEndIn: (row: TaskRow) => {
        const start = new Date(row.created_at);
        const now = new Date();
        const totalSeconds = Math.floor((now.getTime() - start.getTime()) / 1000);
        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        // const minutes = Math.floor((totalSeconds % 3600) / 60);
        const out: string[] = [];
        const addUnit = (num: number, label: string) => {
          if (num > 0) {
            out.push(num + ' ' + label + (num > 1 ? 's' : ''));
          }
        };
        addUnit(days, 'day');
        addUnit(hours, 'hour');
        // addUnit(minutes, 'minute');
        if (out.length === 0) {
          return 'less than an hour';
        }
        return out.join(', ');
      },
    };
  });
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'status', operator: 'eq', value: 'ACTIVE', display: 'hidden' },
        { fieldId: 'type', operator: 'ni', value: ['ROOT', 'PARALLEL-GROUP', 'SEQUENTIAL-GROUP'], display: 'hidden' },
      ],
    },
    order: [['created_at', 'ASC']],
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(LocalTask, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(LocalTask, queryOptions);

  return (
    <Section>
      <PaginatorAndListSettings
        entity={LocalTask}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
